export default "__VITE_ASSET__ClwlXuoV__"